function decodeHtmlEntities(value) {
  return String(value || '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
}

function normalizeTreeItemName(value) {
  return decodeHtmlEntities(value).replace(/\s+/g, ' ').trim();
}

function treeItemSortLabel(item) {
  const name = normalizeTreeItemName(item?.name || item?.product_name || '');
  const price = Number(item?.price_num);
  if (Number.isFinite(price) && price > 0) {
    return `${name} · ${Math.round(price)}`.toLowerCase();
  }
  return name.toLowerCase();
}

function compareTreeItemsByName(a, b) {
  const byName = treeItemSortLabel(a).localeCompare(
    treeItemSortLabel(b),
    undefined,
    { sensitivity: 'base', numeric: true },
  );
  if (byName !== 0) return byName;
  return Number(a?.id || 0) - Number(b?.id || 0);
}

export function sortCategoriesByName(categories = []) {
  return [...categories].sort(compareTreeItemsByName);
}

export function sortProductsByName(products = []) {
  return [...products].sort(compareTreeItemsByName);
}

/** Collect products on this node and all descendant categories. */
export function collectDescendantProducts(node) {
  const items = [];
  const walk = (current) => {
    if (!current) return;
    const products = Array.isArray(current.products) ? current.products : [];
    items.push(...products);
    const children = Array.isArray(current.children) ? current.children : [];
    children.forEach(walk);
  };
  walk(node);
  return items;
}

export function dedupeProductsById(products = []) {
  const seen = new Set();
  const out = [];
  products.forEach((product) => {
    const id = Number(product?.id);
    const key = Number.isFinite(id) && id > 0 ? `id:${id}` : `name:${treeItemSortLabel(product)}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push(product);
  });
  return out;
}

/** Light row highlight on mouseover for revenue report tables. */
export function revenueTreeRowSx(row) {
  const isAvailableProduct = row?.type === 'product' && Number(row?.metrics?.unique_sponsors || 0) === 0;
  return {
    ...(isAvailableProduct ? { bgcolor: '#e3f2fd' } : {}),
    '&:hover': {
      bgcolor: isAvailableProduct ? 'rgba(25, 118, 210, 0.22)' : 'action.hover',
    },
  };
}

export const revenueTableRowHoverSx = {
  '&:hover': { bgcolor: 'action.hover' },
};
